// Config-driven steps for the Client portal onboarding tour.
// Edit/reorder freely - each step just needs a `target` that matches a
// data-onboarding="..." attribute already tagged in the app shell/pages.

// Exported on its own so the Client Profile page tour (see
// `clientProfileOnboardingSteps.js`) can reuse this exact step for its
// own "navbar" step, keeping that part of the experience consistent
// between both tours instead of redefining it twice.
export const clientNavProfileStep = {
  target: '[data-onboarding="client-nav-profile"]',
  title: 'My Profile',
  description: 'View and update your account and company details from your profile page.',
  placement: 'bottom',
};

const clientOnboardingSteps = [
  {
    target: '[data-onboarding="client-logo"]',
    title: 'Welcome to BlackBox',
    description:
      "This is your client portal. In a few quick steps we'll show you where to submit onboarding forms, track their status, and manage your profile.",
    placement: 'bottom',
  },
  {
    target: '[data-onboarding="client-nav-onboarding"]',
    title: 'Onboarding',
    description:
      'This brings you back here anytime - start a new onboarding form or check on ones you already submitted.',
    placement: 'bottom',
  },
  clientNavProfileStep,
  {
    target: '[data-onboarding="client-user-menu"]',
    title: 'Your account',
    description: 'See who you are logged in as, and securely sign out from this menu when you are done.',
    placement: 'bottom',
  },
  {
    target: '[data-onboarding="client-service-tiles"]',
    title: 'Start an onboarding form',
    description:
      'Pick the type of project you need - Weddings, Website/App, Marketing, or Branding - to fill out its onboarding form.',
    placement: 'bottom',
  },
  {
    target: '[data-onboarding="client-submissions"]',
    title: 'Your submissions',
    description: 'Every form you submit shows up in this list, so you can keep track of its status at a glance.',
    placement: 'top',
  },
  {
    target: '[data-onboarding="client-month-filter"]',
    title: 'Filter by month',
    description: 'Use this to narrow the submissions list down to a specific month.',
    placement: 'left',
  },
  {
    target: '[data-onboarding="client-submission-actions"]',
    title: 'Manage a submission',
    description:
      'Use these actions to view details, edit a draft, submit it for review, or download a completed form as a PDF.',
    placement: 'left',
  },
];

export default clientOnboardingSteps;
